export default "__VITE_ASSET__CfbX304S__"